import state from './user-state';
import mutations from './user-mutations';
import actions from './user-actions';
import getters from './user-getters';

const mergedState = { ...state(), ...window.__RMP_USER__ };

export default {
  namespaced: true,
  state: mergedState,
  mutations,
  actions,
  getters,
};
